import { subCategoryFields } from '../../config/endpoint-fields/categories.fields';

export const categoryCssHierarchyFields = [
  'code',
  'liveChatAgentConfig(FULL)',
  'name',
  'description',
  'showChat',
  'url',
  'faqs',
  'additionalMarketingDatas',
  `subCategories(${subCategoryFields.join(',')})`,
  'metaTags',
  'products'
];
